import { faAngleRight, faCheck, faEye, faVideo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import './styles.css'
import { useUserStorage } from '../../../storage/user';
import { useCursosStorage } from '../../../storage/cursos';
export default function MenuAula() {

    const { selectedCurso, selectedAula } = useCursosStorage(state => state).dados
    const { setSelectedAula } = useCursosStorage(state => state.dispatch)

    useEffect(() => {

    }, [selectedCurso])

    return (
        <div style={{ background: '#EFF1F6', height: '100%' }}>
            <h2 style={{ height: '70px', display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                Conteúdo do curso
            </h2>

            {
                selectedCurso && selectedCurso?.modulos?.map(item => {
                    return (
                        <SummaryAula item={item} setSelectedAula={setSelectedAula} />
                    )
                })
            }

        </div>
    )
}


function SummaryAula({ item, setSelectedAula }) {

    const [isOpen, setIsOpen] = useState(false);

    const toggleSummary = () => {
        setIsOpen(isOpen);
    };

    return (
        <details className='detailsContent' open={isOpen}>
            <summary className='summaryContent' onClick={toggleSummary}><h4>{item.titulo}</h4> <FontAwesomeIcon color='#3E64DE' icon={faAngleRight} size='1x' /></summary>
            {
                item.aulas.map(aula => {
                    return (
                        <Card setSelectedAula={setSelectedAula} icon={faVideo} aula={aula} icon2={faCheck} title={aula.titulo} time={aula.duracao} complete={aula.assistido} />
                    )
                })
            }

            {/* <Card icon={faVideo} icon2={faCheck} title={'Abordagem Clássica'} time={'00:00'} complete={true} />
            <Card icon={faVideo} icon2={faCheck} title={'Abordagem Clássica'} time={'00:00'} />
            <Card icon={faVideo} icon2={faCheck} title={'Abordagem Clássica'} time={'00:00'} />
            <Card icon={faVideo} icon2={faCheck} title={'Abordagem Clássica'} time={'00:00'} /> */}
        </details>
    )
}

function Card({ title, icon, icon2, time, complete, setSelectedAula, aula }) {


    return (
        <div onClick={() => { setSelectedAula(aula) }} style={{ cursor: 'pointer', padding: '0 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '40px', background: '#fff' }}>
            <div style={{ display: 'flex' }}>
                <FontAwesomeIcon icon={icon} style={{ alignSelf: 'center', marginRight: '10px', color: '#cacaca' }} />
                <h5>{title}</h5>

            </div>
            <div style={{ width: '25px', height: '25px'}}>

                {
                    complete ?
                        <div style={{ display: 'flex', width: '24px', height: '24px', borderRadius: '50px', background: '#54af63', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <FontAwesomeIcon icon={icon2} size='sm' style={{ alignSelf: 'center', color: '#fff' }} />
                        </div>
                        :
                        <div style={{ display: 'flex', width: '20px', height: '20px', borderRadius: '50px', background: '#fff', display: 'flex', border: '2px solid #d4d6db', justifyContent: 'center', alignItems: 'center' }}></div>

                }
            </div>


        </div>
    )
}

